import React from 'react';
import { Link } from 'react-router-dom';
import { useClearLocalData } from '../hooks/useTravelBuddy';
import * as T from '../ui/inlineTheme';

export function SettingsPage() {
  const clearData = useClearLocalData();

  const dangerBtn: React.CSSProperties = {
    ...T.btnSecondary,
    width: '100%',
    marginTop: 12,
    borderColor: '#991b1b',
    backgroundColor: 'rgba(69, 10, 10, 0.5)',
    color: '#fecaca',
  };

  return (
    <div style={T.page}>
      <h1 style={T.h1}>Settings</h1>
      <p style={T.bodyMuted}>
        Travel Buddy keeps data in this browser only. Delete individual trips from the trip list or trip screen.
      </p>

      <div
        style={{
          ...T.cardSolid,
          marginTop: 24,
          borderColor: 'rgba(153, 27, 27, 0.5)',
          backgroundColor: 'rgba(50, 10, 10, 0.35)',
        }}
      >
        <h2 style={{ ...T.h2, color: '#fecaca', marginBottom: 8 }}>Danger zone</h2>
        <p style={{ ...T.bodyMuted, margin: 0 }}>
          Clear all Travel Buddy data in this browser (trips, receipts, lists, templates).
        </p>
        <button
          type="button"
          disabled={clearData.isPending}
          onClick={() => {
            if (window.confirm('Delete all Travel Buddy data on this device?')) {
              clearData.mutate();
            }
          }}
          style={{
            ...dangerBtn,
            opacity: clearData.isPending ? 0.6 : 1,
          }}
        >
          {clearData.isPending ? 'Clearing…' : 'Clear local data'}
        </button>
      </div>

      <p style={{ marginTop: 32, textAlign: 'center', fontFamily: T.font, fontSize: 13, color: '#52525b' }}>
        <Link to="/" style={{ color: '#9CA3AF', textDecoration: 'none' }}>
          ← Back to Sisuforge home
        </Link>
      </p>
    </div>
  );
}
